import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { Tooltip as i } from "@vds-core/tooltips";
import { Body as t } from "@vds-core/typography";
import { calculateRem as l, withVDSManager as r, checkIfMobileDevice as n, getOS as a } from "@vds-core/utilities";
import { ColorTokens as c } from "@vds-tokens/color";
import { LayoutTokens as d } from "@vds-tokens/layout";
import s from "styled-components";
var p = {
    disabled: !1,
    label: void 0,
    required: !0,
    labelMarginBottom: l(4),
    type: void 0,
    tooltipTitle: void 0,
    tooltipContent: void 0,
    tooltipCloseButtonText: void 0,
    surface: "light",
    calculateLabelColor: function calculateLabelColor(e, o) {
      var i;
      return i = e ? "dark" === o ? c.interactive.disabled.ondark.value : c.interactive.disabled.onlight.value : "dark" === o ? c.elements.primary.ondark.value : c.elements.primary.onlight.value, i;
    },
    calculateOptionalLabelColor: function calculateOptionalLabelColor(e, o) {
      return e && "dark" !== o ? c.interactive.disabled.onlight.value : e && "dark" === o ? c.interactive.disabled.ondark.value : e || "dark" !== o ? c.elements.secondary.onlight.value : c.elements.secondary.ondark.value;
    },
    renderSecurityCodeTooltipDialog: !0
  },
  u = s.label.withConfig({
    displayName: "LabelWrapper",
    componentId: "VDS__sc-13hvypf-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  margin-bottom: ", ";\n  width: ", ";\n  ", ";\n"])), function (_ref) {
    var e = _ref.$labelMarginBottom,
      o = _ref.label;
    return o ? e : 0;
  }, function (_ref2) {
    var e = _ref2.$helperText,
      o = _ref2.$helperTextPlacement;
    return e && "right" === o ? "50%" : "100%";
  }, function (_ref3) {
    var e = _ref3.$focusState;
    return e && "\n    &:focus,\n    &:active {\n      outline: none;\n    }\n  ";
  }),
  m = s.span.withConfig({
    displayName: "OptionalLabel",
    componentId: "VDS__sc-13hvypf-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0 0 0 4px;\n  outline: none;\n  color: ", ";\n"])), function (_ref4) {
    var e = _ref4.color;
    return e;
  }),
  h = s.span.withConfig({
    displayName: "CVVTooltipWrapper",
    componentId: "VDS__sc-13hvypf-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: ", ";\n  height: ", ";\n"])), function (_ref5) {
    var e = _ref5.cardType;
    return "other" !== e && void 0 !== e ? "column" : "row";
  }, function (_ref6) {
    var e = _ref6.cardType,
      o = _ref6.isTooltipDialog;
    return function (e, o) {
      return o ? "other" !== e && void 0 !== e ? "148px" : "184px" : "other" !== e && void 0 !== e ? "124px" : "160px";
    }(e, o);
  }),
  f = s.span.withConfig({
    displayName: "CVVIconWrapper",
    componentId: "VDS__sc-13hvypf-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  padding-bottom: ", ";\n"])), function (_ref7) {
    var e = _ref7.isTooltipDialog;
    return l(e ? 126 : 96);
  }, function (_ref8) {
    var e = _ref8.isTooltipDialog;
    return l(e ? 94 : 71);
  }, function (_ref9) {
    var e = _ref9.isTooltipDialog;
    return l(e ? d.space["3X"].value : d.space["2X"].value);
  }),
  v = s.span.withConfig({
    displayName: "ColumnWrapper",
    componentId: "VDS__sc-13hvypf-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  padding-right: ", ";\n"])), function (_ref0) {
    var e = _ref0.secondCol,
      o = _ref0.isTooltipDialog;
    return e ? 0 : l(o ? d.space["3X"].value : d.space["2X"].value);
  }),
  g = s.span.withConfig({
    displayName: "AlignTooltip",
    componentId: "VDS__sc-13hvypf-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: text-bottom;\n  height: ", ";\n"])), l(15)),
  y = function y(l) {
    var r = l.id,
      d = l.disabled,
      s = l.required,
      p = l.label,
      y = l.tooltip,
      T = l.tooltipTitle,
      b = l.tooltipContent,
      x = l.tooltipCloseButtonText,
      C = l.type,
      $ = l.labelMarginBottom,
      D = l.helperText,
      k = l.helperTextPlacement,
      _ = l.focusState,
      S = l.htmlFor,
      w = l.surface,
      V = l.calculateLabelColor,
      B = l.calculateOptionalLabelColor,
      I = l.renderSecurityCodeTooltipDialog,
      L = n() || !1;
    var z = y && y.title || T || y && y.children || b || "securityCode" === C,
      N = "android" === a(),
      O = "ios" === a();
    return e(u, {
      "data-testid": "test-label",
      id: r,
      $focusState: _,
      $labelMarginBottom: $,
      label: p,
      $helperTextPlacement: k,
      $helperText: D,
      htmlFor: S,
      children: o(t, {
        id: "".concat(r, "-text"),
        size: "small",
        primitive: "p",
        color: null == V ? void 0 : V(d, w),
        children: [p, !s && e(m, {
          id: r,
          "aria-label": N || O ? "Optional" : p,
          color: null == B ? void 0 : B(d, w),
          children: "Optional"
        }), z && e(g, {
          children: e(i, Object.assign({}, y && y, {
            size: "small",
            disabled: d,
            title: "securityCode" === C ? null : y && y.title ? y.title : T && T,
            surface: w,
            ariaLabel: "".concat(p, " tooltip"),
            closeButtonText: y && y.closeButtonText ? y.closeButtonText : x || "Close",
            children: "securityCode" === C ? function () {
              var i = l.cardType,
                r = l.CreditCardIcon,
                n = "amex" === i ? "securityCodeAmex" : "securityCode",
                a = "dark" === w ? c.elements.primary.ondark.value : c.elements.primary.onlight.value,
                d = "Most credit or debit cards have a 3-digit security code on the\n    back.",
                s = "American Express cards have a 4-digit code on the front.",
                p = L && I;
              return o(h, "other" !== i && void 0 !== i ? {
                cardType: i,
                isTooltipDialog: p,
                children: [e(f, {
                  isTooltipDialog: p,
                  children: r && e(r, {
                    surface: w,
                    name: n
                  })
                }), e(t, {
                  color: a,
                  size: p ? "large" : "small",
                  primitive: "span",
                  children: "amex" === i ? s : d
                })]
              } : {
                cardType: i,
                isTooltipDialog: p,
                children: [o(v, {
                  isTooltipDialog: p,
                  children: [e(f, {
                    isTooltipDialog: p,
                    children: r && e(r, {
                      surface: w,
                      name: "securityCode"
                    })
                  }), L ? e(t, {
                    color: a,
                    primitive: "span",
                    size: p ? "large" : "small",
                    children: d
                  }) : o(t, {
                    color: a,
                    primitive: "span",
                    size: p ? "large" : "small",
                    children: [d, " "]
                  })]
                }), o(v, {
                  secondCol: !0,
                  isTooltipDialog: p,
                  children: [e(f, {
                    isTooltipDialog: p,
                    children: r && e(r, {
                      surface: w,
                      name: "securityCodeAmex"
                    })
                  }), e(t, {
                    color: a,
                    primitive: "span",
                    size: p ? "large" : "small",
                    children: s
                  })]
                })]
              });
            }() : y && y.children ? y.children : b && b
          }))
        })]
      })
    });
  };
y.defaultProps = p;
var T = r(y);
export { T as default };